import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { lighten, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import Button from "@material-ui/core/Button";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import DeleteIcon from "@material-ui/icons/Delete";
import { Link, useNavigate } from "react-router-dom";
import Alert from "@material-ui/lab/Alert";
import { CSVLink, CSVDownload } from "react-csv";
import GetAppIcon from "@material-ui/icons/GetApp";
import SearchBar from "material-ui-search-bar";
import { fetchWithToken } from "../../../apiUtils";

function descendingComparator(a, b, orderBy) {
  if (a[orderBy] === null) {
    return 1;
  } else if (b[orderBy] === null) {
    return -1;
  }
  if (orderBy === "name") {
    return a[orderBy].toLowerCase().localeCompare(b[orderBy].toLowerCase());
  } else if (b[orderBy] < a[orderBy]) {
    return -1;
  } else if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator, domain) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  { id: "name", label: "Pool", key: "name" },
  { id: "startNumber", label: "Start", key: "startNumber" },
  { id: "endNumber", label: "End", key: "endNumber" },
  { id: "totalCount", label: "Total Count", key: "totalCount" },
  { id: "availableCount", label: "Available Count", key: "availableCount" },
  { id: "assigned", label: "Assigned", key: "assigned" },
  { id: "ownerTechnology", label: "Owner Technology", key: "ownerTechnology" },
  { id: "description", label: "Onboarding Status", key: "description" },
];

function RangesTableHead(props) {
  const {
    classes,
    order,
    orderBy,
    onRequestSort,
    searchedObj,
    getTotalAssigned,
    setSearched,
    setPage,
  } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const handleInput = (searchVal, domain) => {
    setPage(0);
    setSearched({ searched: searchVal, domain: domain });
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align="center"
            paddingBottom="50px"
            style={{ fontSize: ".80vw", padding: "5px" }}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <div
              class="input-group"
              style={
                headCell.id == "name" ||
                headCell.id == "startNumber" ||
                headCell.id == "endNumber"
                  ? {
                      justifyContent: "center",
                      marginBottom: "8px",
                      width: "205px",
                    }
                  : { justifyContent: "center", marginBottom: "8px" }
              }
            >
              {headCell.id == "name" && (
                <SearchBar
                  placeholder="Pool"
                  value={
                    searchedObj.domain === "name" ? searchedObj.searched : ""
                  }
                  onChange={(searchVal) => handleInput(searchVal, "name")}
                  onCancelSearch={() => setSearched("")}
                  className={classes.searchbar}
                  style={{ width: "80%" }}
                />
              )}
              {headCell.id == "startNumber" && (
                <SearchBar
                  placeholder="Start"
                  value={
                    searchedObj.domain === "startNumber"
                      ? searchedObj.searched
                      : ""
                  }
                  onChange={(searchVal) =>
                    handleInput(searchVal, "startNumber")
                  }
                  onCancelSearch={() => setSearched("")}
                  className={classes.searchbar}
                  style={{ width: "80%" }}
                />
              )}
              {headCell.id == "endNumber" && (
                <SearchBar
                  placeholder="End"
                  value={
                    searchedObj.domain === "endNumber"
                      ? searchedObj.searched
                      : ""
                  }
                  onChange={(searchVal) => handleInput(searchVal, "endNumber")}
                  onCancelSearch={() => setSearched("")}
                  className={classes.searchbar}
                  style={{ width: "80%" }}
                />
              )}

              {headCell.id != "ownerTechnology" &&
                headCell.id != "description" && (
                  <TableSortLabel
                    active={orderBy === headCell.id}
                    direction={orderBy === headCell.id ? order : "asc"}
                    onClick={createSortHandler(headCell.id)}
                  >
                    {(headCell.id == "totalCount" ||
                      headCell.id == "availableCount") && (
                      <div align="center" style={{ fontSize: ".8vw" }}>
                        {headCell.label}
                      </div>
                    )}
                    {headCell.id == "assigned" && (
                      <div align="center" style={{ fontSize: ".8vw" }}>
                        {headCell.label} {getTotalAssigned()}
                      </div>
                    )}
                    {orderBy === headCell.id ? (
                      <span className={classes.visuallyHidden}>
                        {order === "desc"
                          ? "sorted descending"
                          : "sorted ascending"}
                      </span>
                    ) : null}
                  </TableSortLabel>
                )}
            </div>

            {headCell.id == "ownerTechnology" && (
              <select
                class="form-control"
                name="ownerTechnology"
                style={{
                  width: "145px",
                  height: "40px",
                  fontSize: ".7vw",
                  margin: "auto",
                  marginBottom: "12px",
                }}
                onChange={(searchVal) =>
                  handleInput(
                    searchVal.target.value.toString(),
                    "ownerTechnology"
                  )
                }
              >
                <option value=""> Technology </option>
                <option value="IPT">IPT</option>
                <option value="TEAMS">TEAMS</option>
              </select>
            )}
            {headCell.id == "description" && (
              <select
                class="form-control"
                name="description"
                style={{
                  width: "145px",
                  height: "40px",
                  fontSize: ".7vw",
                  margin: "auto",
                  marginBottom: "12px",
                }}
                onChange={(searchVal) =>
                  handleInput(searchVal.target.value.toString(), "description")
                }
              >
                <option value=""> Status </option>
                <option value="Pending Carrier Delivery">
                  Pending Carrier Delivery
                </option>
                <option value="Pending Carrier Activation">
                  Pending Carrier Activation
                </option>
                <option value="Pending GM Implementation">
                  Pending GM Implementation
                </option>
                <option value="Active">Active</option>
                <option value="Pending Off-Board">Pending Off-Board</option>
                <option value="Deleted">Deleted</option>
              </select>
            )}
          </TableCell>
        ))}

        <TableCell
          align="center"
          padding="0px"
          style={{ fontSize: ".80vw", paddingBottom: "25px" }}
        >
          Endpoints
        </TableCell>
        <TableCell
          align="center"
          padding="0px"
          style={{ fontSize: ".80vw", paddingBottom: "25px" }}
        >
          Edit
        </TableCell>
        <TableCell
          align="center"
          padding="0px"
          style={{ fontSize: ".80vw", paddingBottom: "25px" }}
        >
          Delete
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

RangesTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
    margin: 40,
  },
  csvLink: {
    width: "500px",
  },
}));

const RangesTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { data } = props;

  return (
    <Toolbar className={classes.root}>
      <Typography
        className={classes.title}
        variant="h6"
        id="tableTitle"
        component="div"
      >
        Ranges
      </Typography>
      <div style={{ width: "250px" }}>
        <CSVLink
          data={data.map((p) => {
            return Object.assign({
              startNumber: `=""${p.startNumber}""`,
              endNumber: `=""${p.endNumber}""`,
              totalCount: p.totalCount,
              availableCount: p.availableCount,
              description: p.description,
              ownerTechnology: p.ownerTechnology,
              assigned: p.assigned,
              name: p.name,
            });
          })}
          headers={headCells}
          filename={"dmv_Ranges_Export.csv"}
        >
          <GetAppIcon />
          Download Ranges
        </CSVLink>
      </div>
    </Toolbar>
  );
};

RangesTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  smallColumn: {
    width: "10px",
  },
  searchbar: {
    width: "200px",
    height: "40px",
  },
}));

const RangesSearchTable = (props) => {
  const { data, authObj } = props;
  const history = useNavigate();
  const classes = useStyles();
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("id");
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [rows, setRows] = useState(data);
  const [searchedObj, setSearched] = useState({ searched: "", domain: "" });

  var editable = !authObj.roles.includes("admin");

  useEffect(() => {
    setRows(data);
  }, [data]);

  const handleFilter = () => {
    const filteredRows = rows.filter((row) => {
      if (searchedObj.domain === "name" && row.name != null) {
        return row.name
          .toString()
          .toLowerCase()
          .includes(searchedObj.searched.toLowerCase());
      }
      if (searchedObj.domain === "startNumber" && row.startNumber != null) {
        return row.startNumber
          .toString()
          .toLowerCase()
          .includes(searchedObj.searched.toLowerCase());
      }
      if (searchedObj.domain === "endNumber" && row.endNumber != null) {
        return row.endNumber
          .toString()
          .toLowerCase()
          .includes(searchedObj.searched.toLowerCase());
      }
      if (
        searchedObj.domain === "ownerTechnology" &&
        row.ownerTechnology != null
      ) {
        return row.ownerTechnology
          .toString()
          .toLowerCase()
          .includes(searchedObj.searched.toLowerCase());
      }
      if (searchedObj.domain === "description" && row.description != null) {
        return row.description
          .toString()
          .toLowerCase()
          .includes(searchedObj.searched.toLowerCase());
      } else return rows;
    });
    return filteredRows;
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const [alertMessage, setAlertMessage] = useState({
    message: "",
    active: false,
  });

  const handleDelete = (id) => {
    var successfulResponse = false;

    fetchWithToken(`api/Ranges/` + id, "DELETE")
      .then((res) => {
        console.log("res", res.ok);
        if (res.ok) {
          successfulResponse = true;
          let newRows = rows.filter((row) => row.id != id);
          setRows(newRows);
        }
        return res.json();
      })
      .then((data) => {
        console.log("successfulResponse", successfulResponse);
        sendAlert(data.returnMessage, successfulResponse ? "success" : "error");
        console.log("Data Returned: ", data.returnObject);
      });
  };

  const sendAlert = (message, varient) => {
    setAlertMessage({
      message: message,
      varient: varient,
      active: true,
    });
  };

  const clearAlert = () => {
    setAlertMessage({
      message: "",
      varient: "",
      active: false,
    });
  };

  const getTotalAssigned = () => {
    var finalValue = 0;
    rows.map((r) => {
      finalValue += r.assigned;
    });
    return finalValue;
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    handleFilter().length < rowsPerPage
      ? 0
      : rowsPerPage -
        Math.min(rowsPerPage, handleFilter().length - page * rowsPerPage);

  return (
    <>
      <div className={classes.root}>
        <Paper className={classes.paper}>
          {alertMessage.active && (
            <Alert severity={alertMessage.varient} onClose={() => clearAlert()}>
              {alertMessage.message}
            </Alert>
          )}
          <RangesTableToolbar numSelected={selected.length} data={rows} />
          <TableContainer>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size="medium"
              aria-label="enhanced table"
            >
              <RangesTableHead
                classes={classes}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={handleFilter().length}
                getTotalAssigned={getTotalAssigned}
                searchedObj={searchedObj}
                setSearched={setSearched}
                setPage={setPage}
              />
              <TableBody>
                {stableSort(
                  handleFilter(),
                  getComparator(order, orderBy),
                  orderBy
                )
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    return (
                      <TableRow
                        hover
                        tabIndex={-1}
                        key={row.id}
                        style={{
                          height: "93px",
                          background: index % 2 ? "#f8f8f8" : "white",
                        }}
                      >
                        {/*<TableCell align="center" style={{ minWidth: '133px' }}>{row.id}</TableCell>*/}
                        <TableCell align="left" style={{ minWidth: "248px" }}>
                          {row.name}
                        </TableCell>
                        <TableCell align="left" style={{ minWidth: "178px" }}>
                          {row.startNumber}
                        </TableCell>
                        <TableCell align="left" style={{ minWidth: "178px" }}>
                          {row.endNumber}
                        </TableCell>
                        <TableCell align="center">{row.totalCount}</TableCell>
                        <TableCell align="center">
                          {row.availableCount}
                        </TableCell>
                        <TableCell align="center">{row.assigned}</TableCell>
                        <TableCell align="center">
                          {row.ownerTechnology}
                        </TableCell>
                        <TableCell align="center">{row.description}</TableCell>

                        <TableCell align="center" style={{ width: "5%" }}>
                          <Link
                            to={`/phoneNumbers/byRange/${row.id}`}
                            style={{ textDecoration: "none" }}
                          >
                            <Button variant="contained" size="small">
                              <VisibilityIcon />
                            </Button>
                          </Link>
                        </TableCell>
                        <TableCell align="center">
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() => history(`/ranges/edit/${row.id}`)}
                            disabled={editable}
                          >
                            <EditIcon />
                          </Button>
                        </TableCell>
                        <TableCell align="center">
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={(e) => {
                              if (
                                window.confirm(
                                  `Are you sure you wish to delete Range ${row.id}?`
                                )
                              )
                                handleDelete(row.id);
                            }}
                            disabled={editable}
                          >
                            <DeleteIcon />
                          </Button>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow
                    style={{
                      height:
                        handleFilter().length > rowsPerPage
                          ? 93 * emptyRows
                          : 93,
                    }}
                  >
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 15]}
            component="div"
            count={handleFilter().length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangeRowsPerPage={handleChangeRowsPerPage} // Material v < 4
            onRowsPerPageChange={handleChangeRowsPerPage} // Material v > 4
            onPageChange={handleChangePage} // Material v > 4
            onChangePage={handleChangePage} // Material v < 4
          />
        </Paper>
      </div>
    </>
  );
};

export default RangesSearchTable;
